import React, { useState, useEffect } from "react";

import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";

import { Button } from "@mui/material";

import DB from "_DatabaseFunctions/directConnect";

const useStyles = makeStyles(() => ({
  formContainer: {
    width: "70%",
  },
}));

interface AddToCurrentPlayersFieldProps {
  gameInfo: {
    id: string;
    status: string;
    currentPlayers: Record<string, unknown>;
    maxPlayers: number;
  };
  setModalDets: (dets: { open: boolean; status: string }) => void;
}

export default function AddToCurrentPlayersField({ gameInfo, setModalDets }: AddToCurrentPlayersFieldProps) {
  const classes = useStyles();

  const [playerName, setPlayerName] = useState("");
  const gameId = gameInfo.id;

  const [msg, setMsg] = useState("");

  const addPlayerManually = async (event: React.FormEvent) => {
    event.preventDefault();
    if (gameInfo.status !== "Running") {
      setModalDets({
        open: true,
        status: "errorRunning",
      });
    } else if (
      Object.keys(gameInfo.currentPlayers).length >= gameInfo.maxPlayers
    ) {
      setModalDets({
        open: true,
        status: "errorMaxPlayers",
      });
    } else {
      const res = await DB.addPlayerToTableManually(gameId, playerName);
      setMsg(res.msg);
      setPlayerName("");
    }
  };

  return (
    <Container className={classes.formContainer}>
      <form
        onSubmit={(event) => addPlayerManually(event)}
        className="form-styles"
      >
        <input
          type="text"
          name="name"
          value={playerName}
          onChange={(event) => setPlayerName(event.target.value)}
          className="form-text-input"
          placeholder="Player Name"
        />
        <Button variant="success" onClick={(event) => addPlayerManually(event)}>
          Add Player To Game
        </Button>
      </form>
      <br />
      <div style={{ color: "red" }}>
        <h5>{msg}</h5>
      </div>
    </Container>
  );
}
